<template>
  <div class="container">
    <slot />
  </div>
</template>

<style>
.container {
  max-width: 1310px;
  padding: 0 10px;
  margin: 0 auto;
}
</style>
